import { useId } from 'react';
import { IconPropsType } from '..';

export const Vatan = ({ ...props }: IconPropsType) => {
  // Generating unique id for the SVG definitions
  const uniqueId = useId();

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id={`Vatan_Coin_Icon_${uniqueId}`}
        clipPath={`url(#clip0_${uniqueId})`}
      >
        <path
          id={`Vector_${uniqueId}`}
          d="M12.0058 23.9569C18.6127 23.9569 23.9687 18.601 23.9687 11.9941C23.9687 5.38717 18.6127 0.0312195 12.0058 0.0312195C5.39892 0.0312195 0.0429688 5.38717 0.0429688 11.9941C0.0429688 18.601 5.39892 23.9569 12.0058 23.9569Z"
          fill={`url(#paint0_linear_${uniqueId})`}
        />
        <path
          id={`Vector_2_${uniqueId}`}
          d="M13.6568 5.57573L12.4055 8.13251L14.8159 7.44223L11.4693 18.1546L12.0994 11.1515L10.0241 11.9799L9.20455 5.16112L5.20703 3.22849L12.0095 22.8007L18.8112 3.22849L13.6568 5.57573Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_${uniqueId}`}
          x1="0.0429688"
          y1="11.9941"
          x2="23.9679"
          y2="11.9941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF8218" />
          <stop
            offset="0.72"
            stopColor="#EF8218"
          />
        </linearGradient>
        <clipPath id={`clip0_${uniqueId}`}>
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
